import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios';
import Book from './Book';
import './Book.css';

const URL = 'https://bookstore-hyob.onrender.com/books';

const fetchHandler = async () => {
    return await axios.get(URL).then((res) => res.data)
}

function Books() {
    const [books, setBooks] = useState();
    useEffect(() => {
        fetchHandler().then(data => setBooks(data.books));
    }, [])
    console.log(books)
    return (
        <div className='books'>
                <ul>
                {books && books.map((book, i) => {
                    return (
                        <>
                            <li className='book' key={i}>
                                <Book book={book} />
                            </li>
                        </>
                    )
                })}
                </ul>
        </div>
    )
}

export default Books;